import React from 'react'
import IntroApi from './IntroGetStarted'

export default function Home () {
    return <div className="adobe-app-main">
        <IntroApi />
    </div>
}
